export default __webpack_public_path__ + "static/media/P330_A_BD.f6d86d94.pdf";